import styled, { css, keyframes } from "styled-components";
import { colors, radius, shadow } from "../../../styles/theme/tokens";

// Стилі «живих» блоків: макети (пост, лист, меню, відгуки), підказки, картки-факти, формули, кошики, «знайди помилку»

const rise = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;
const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  25% { transform: translateX(-6px); }
  75% { transform: translateX(6px); }
`;

// ---------- макети ----------
export const MockWrap = styled.div`
  min-height: 0;
  overflow-y: auto;
  animation: ${rise} 0.4s ease-out;
`;

// Пост у соцмережі
export const Post = styled.div`
  max-width: 470px;
  margin: 0 auto;
  border: 1px solid #dbdbdb;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: ${shadow.card};
  font-family: -apple-system, "Segoe UI", Roboto, sans-serif;
  overflow: hidden;
`;
export const PostHead = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  font-size: 15px;
  b { font-weight: 700; }
  span { color: #8e8e8e; font-size: 13px; }
`;
export const Avatar = styled.div`
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  padding: 2px;
  background: linear-gradient(45deg, #f9ce34, #ee2a7b, #6228d7);
  div {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid #fff;
    background: ${colors.brandSoft} center / cover;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 800;
    color: ${colors.brandDeep};
  }
`;
export const PostImage = styled.img`
  display: block;
  width: 100%;
  height: 250px;
  object-fit: cover;
`;
export const PostIcons = styled.div`
  display: flex;
  gap: 14px;
  padding: 10px 14px 4px;
  font-size: 22px;
  span:last-child { margin-left: auto; }
`;
export const PostText = styled.div`
  padding: 2px 14px 12px;
  font-size: 16px;
  line-height: 1.45;
  p { margin: 4px 0; }
  small { display: block; color: #8e8e8e; font-size: 13px; margin-top: 6px; }
`;

// Лист у поштовому клієнті
export const Mail = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: ${radius.lg};
  background: #ffffff;
  box-shadow: ${shadow.card};
  overflow: hidden;
`;
export const MailBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #f1f3f8;
  border-bottom: 1px solid ${colors.line};
  font-size: 14px;
  color: ${colors.muted};
  i { width: 12px; height: 12px; border-radius: 50%; display: inline-block; }
  b { margin-left: 8px; color: ${colors.ink}; }
`;
export const MailHead = styled.div`
  padding: 14px 20px 10px;
  border-bottom: 1px solid ${colors.line};
  font-size: 16px;
  line-height: 1.6;
  h3 { font-size: 22px; font-weight: 800; margin-bottom: 4px; color: ${colors.ink}; }
  span { color: ${colors.muted}; }
`;
export const MailBody = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 14px 20px 18px;
  font-size: 18px;
  line-height: 1.55;
  p { margin-bottom: 10px; }
`;

// Меню ресторану
export const Menu = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 22px 30px;
  border-radius: ${radius.lg};
  background: #fffaf0;
  border: 2px solid #e9dcc0;
  box-shadow: ${shadow.card};
  font-family: Georgia, "Times New Roman", serif;
  color: #3b2f1e;
  h3 { text-align: center; font-size: 30px; letter-spacing: 1px; }
  > small { display: block; text-align: center; font-style: italic; color: #8a7556; margin-bottom: 10px; }
  h4 {
    margin: 14px 0 6px;
    font-size: 15px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: #b0732b;
    border-bottom: 1px dashed #d8c39c;
    padding-bottom: 4px;
  }
`;
export const MenuItem = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2px 12px;
  margin-bottom: 8px;
  font-size: 18px;
  b { font-weight: 700; }
  span { font-weight: 700; color: #b0732b; }
  small { grid-column: 1 / -1; font-size: 15px; font-style: italic; color: #7a6a52; }
`;

// Відгуки
export const Reviews = styled.div`
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const ReviewsHead = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 12px 18px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  h3 { font-size: 22px; font-weight: 800; }
  span { color: ${colors.amberDeep}; font-size: 20px; }
`;
export const Review = styled.div`
  padding: 12px 18px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  font-size: 17px;
  line-height: 1.45;
  header { display: flex; align-items: center; gap: 10px; margin-bottom: 4px; }
  header b { font-size: 16px; }
  header span { color: ${colors.amber}; letter-spacing: 1px; }
  header small { margin-left: auto; color: ${colors.muted}; }
`;

// ---------- підказка в шапці слайда ----------
const tipColors = {
  mistake: { bg: colors.pinkSoft, line: colors.pink, ink: "#9b2453" },
  hack: { bg: colors.amberSoft, line: colors.amber, ink: "#8a5a00" },
  fact: { bg: colors.brandSoft, line: colors.brand, ink: colors.brandDark },
};
export const Tip = styled.button`
  display: flex;
  gap: 10px;
  align-items: flex-start;
  width: 360px;
  flex-shrink: 0;
  padding: 10px 14px;
  border: none;
  border-left: 5px solid ${(p) => tipColors[p.$kind]?.line || colors.brand};
  border-radius: ${radius.md};
  background: ${(p) => tipColors[p.$kind]?.bg || colors.brandSoft};
  color: ${(p) => tipColors[p.$kind]?.ink || colors.ink};
  text-align: left;
  font: inherit;
  font-size: 15px;
  line-height: 1.4;
  cursor: ${(p) => (p.$flip ? "pointer" : "default")};
  box-shadow: ${shadow.card};
  transform: rotate(-1deg);
  animation: ${rise} 0.5s ease-out;
  em { font-size: 24px; font-style: normal; line-height: 1; }
  > span > i { display: block; font-style: normal; font-weight: 800; font-size: 12px; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 2px; }
  small { display: block; margin-top: 4px; font-size: 12px; opacity: 0.7; }
`;

// ---------- картки-факти ----------
export const Facts = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => Math.min(p.$count, 3)}, minmax(0, 1fr));
  gap: 22px;
  height: 100%;
  perspective: 1200px;
`;
export const Fact = styled.button`
  position: relative;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  transform-style: preserve-3d;
  transition: transform 0.6s;
  transform: ${(p) => (p.$flipped ? "rotateY(180deg)" : "none")};
  animation: ${rise} 0.4s ease-out;
`;
const face = css`
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: ${radius.xl};
  backface-visibility: hidden;
  box-shadow: ${shadow.card};
  text-align: left;
`;
export const FactFront = styled.div`
  ${face};
  background: ${colors.surface};
  img { width: 100%; height: 46%; object-fit: cover; }
  div { flex: 1; padding: 16px 20px; font-size: 21px; font-weight: 600; line-height: 1.4; color: ${colors.ink}; }
  div > i { display: block; margin-bottom: 6px; font-style: normal; font-weight: 800; font-size: 13px; letter-spacing: 1px; text-transform: uppercase; color: ${colors.brandDeep}; }
  b { color: ${colors.brandDeep}; }
  small { position: absolute; right: 14px; bottom: 10px; font-size: 13px; color: ${colors.muted}; }
`;
export const FactBack = styled.div`
  ${face};
  justify-content: center;
  padding: 24px;
  transform: rotateY(180deg);
  background: linear-gradient(140deg, ${colors.brand}, ${colors.brandDeep});
  color: #ffffff;
  font-size: 21px;
  font-weight: 600;
  line-height: 1.45;
  div > i { display: block; margin-bottom: 8px; font-style: normal; font-size: 13px; letter-spacing: 1px; text-transform: uppercase; opacity: 0.8; }
  b { color: ${colors.amber}; }
`;

// ---------- граматика: формула й шкала часу ----------
const roleColors = {
  subj: ["#E6F0FF", "#2F6FDB"],
  aux: ["#EEEDFF", "#5652D4"],
  verb: ["#FFF1E3", "#D46B08"],
  end: ["#FDE9EC", "#D6455D"],
  neg: ["#FDE9EC", "#D6455D"],
  obj: ["#E3F6EC", "#17A06A"],
  time: ["#F1F1F5", "#6E6A8A"],
};
export const Formulas = styled.div`
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const Formula = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  font-size: 26px;
  animation: ${rise} 0.4s ease-out both;
  animation-delay: ${(p) => p.$i * 0.25}s;
  > i { font-style: normal; font-weight: 800; color: ${colors.muted}; }
  > em { margin-left: auto; font-style: italic; font-size: 19px; color: ${colors.ink}; }
`;
export const Chip = styled.span`
  padding: 4px 12px;
  border-radius: ${radius.pill};
  font-weight: 800;
  background: ${(p) => (roleColors[p.$role] || roleColors.time)[0]};
  color: ${(p) => (roleColors[p.$role] || roleColors.time)[1]};
  small { display: block; font-size: 11px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; opacity: 0.75; text-align: center; }
`;
export const Timeline = styled.div`
  position: relative;
  flex-shrink: 0;
  height: 118px;
  margin: 6px 24px 0;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 58px;
    height: 4px;
    border-radius: 2px;
    background: ${colors.brand};
  }
  &::after {
    content: "";
    position: absolute;
    right: -6px;
    top: 50px;
    border: 10px solid transparent;
    border-left: 16px solid ${colors.brand};
  }
`;
export const TimeLabel = styled.span`
  position: absolute;
  top: 70px;
  left: ${(p) => p.$at}%;
  transform: translateX(-50%);
  font-size: 15px;
  font-weight: 700;
  color: ${colors.muted};
  text-transform: uppercase;
  letter-spacing: 1px;
`;
export const TimeMark = styled.div`
  position: absolute;
  left: ${(p) => p.$at}%;
  top: 0;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: ${rise} 0.5s ease-out both;
  animation-delay: ${(p) => 0.3 + p.$i * 0.3}s;
  span {
    white-space: nowrap;
    padding: 4px 12px;
    border-radius: ${radius.pill};
    font-size: 17px;
    font-weight: 800;
    color: #ffffff;
    background: ${(p) => p.$color || colors.pink};
  }
  i { width: 18px; height: 18px; margin-top: 12px; border-radius: 50%; border: 4px solid #fff; background: ${(p) => p.$color || colors.pink}; box-shadow: 0 0 0 2px ${(p) => p.$color || colors.pink}; }
`;
export const TimeSpan = styled.div`
  position: absolute;
  left: ${(p) => p.$from}%;
  width: ${(p) => p.$to - p.$from}%;
  top: 52px;
  height: 16px;
  border-radius: 8px;
  background: ${(p) => p.$color || colors.amber};
  opacity: 0.85;
  animation: ${rise} 0.5s ease-out both;
`;

// ---------- кошики ----------
export const BucketsWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
  animation: ${rise} 0.4s ease-out;
`;
export const Pool = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  min-height: 56px;
  padding: 12px;
  border: 2px dashed ${colors.line};
  border-radius: ${radius.lg};
  background: ${colors.surface};
`;
export const Item = styled.button`
  padding: 8px 16px;
  border: 2px solid ${(p) => (p.$picked ? colors.brandDeep : colors.line)};
  border-radius: ${radius.pill};
  background: ${(p) => (p.$picked ? colors.brandSoft : "#fff")};
  font: inherit;
  font-size: 19px;
  font-weight: 700;
  color: ${colors.ink};
  cursor: grab;
  animation: ${(p) => (p.$wrong ? shake : "none")} 0.35s;
  ${(p) => p.$wrong && css`border-color: ${colors.danger}; color: ${colors.danger};`}
`;
export const Buckets = styled.div`
  display: grid;
  grid-template-columns: repeat(${(p) => p.$count}, minmax(0, 1fr));
  gap: 16px;
  flex: 1;
  min-height: 0;
`;
const bucketPalette = [colors.brand, colors.amber, colors.pink, colors.success];
export const Bucket = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: ${radius.lg};
  border: 3px solid ${(p) => (p.$over ? colors.ink : bucketPalette[p.$i % 4])};
  background: ${colors.surface};
  overflow-y: auto;
  cursor: pointer;
  h4 {
    padding: 10px;
    text-align: center;
    font-size: 22px;
    font-weight: 800;
    color: #fff;
    background: ${(p) => bucketPalette[p.$i % 4]};
  }
  div { display: flex; flex-wrap: wrap; gap: 8px; padding: 12px; }
`;
export const Placed = styled.span`
  padding: 6px 14px;
  border-radius: ${radius.pill};
  font-size: 18px;
  font-weight: 700;
  ${(p) => (p.$late ? css`background: ${colors.amberSoft}; color: ${colors.amberDeep};` : css`background: ${colors.successSoft}; color: ${colors.success};`)}
`;
export const TryList = styled.small`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: ${colors.danger};
  text-decoration: line-through;
`;

// ---------- знайди помилку ----------
export const Mistakes = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  animation: ${rise} 0.4s ease-out;
`;
export const MistakeLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 2px;
  padding: 10px 16px;
  border-radius: ${radius.lg};
  background: ${colors.surface};
  box-shadow: ${shadow.card};
  font-size: 22px;
  > b { margin-right: 6px; color: ${colors.muted}; }
`;
export const Word = styled.button`
  padding: 2px 6px;
  border: none;
  border-radius: 8px;
  background: transparent;
  font: inherit;
  color: ${colors.ink};
  cursor: pointer;
  &:hover { background: ${colors.brandSoft}; }
  ${(p) => p.$state === "bad" && css`background: ${colors.dangerSoft}; color: ${colors.danger}; animation: ${shake} 0.35s;`}
  ${(p) =>
    p.$state === "fixed" &&
    css`
      cursor: default;
      s { color: ${colors.danger}; margin-right: 6px; }
      b { padding: 2px 8px; border-radius: 8px; color: ${p.$late ? colors.amberDeep : colors.success}; background: ${p.$late ? colors.amberSoft : colors.successSoft}; }
    `}
`;

// ---------- talk: фото на весь фон ----------
export const BgTalk = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-end;
  padding: 0 56px 40px;
  background: linear-gradient(180deg, rgba(20, 18, 40, 0) 30%, rgba(20, 18, 40, 0.75) 100%), url(${(p) => p.$src}) center / cover;
  animation: ${rise} 0.5s ease-out;
`;
export const BgCards = styled.div`
  display: flex;
  gap: 16px;
  width: 100%;
  div {
    flex: 1;
    padding: 16px 20px;
    border-radius: ${radius.lg};
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: blur(6px);
    font-size: 21px;
    font-weight: 700;
    line-height: 1.35;
    color: ${colors.ink};
    box-shadow: ${shadow.raised};
  }
`;
